import LanguageIcon from '@mui/icons-material/Language'
import { Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import React from 'react'

/** Human-readable language names */
const LANGUAGE_NAMES: Record<string, string> = {
  he: 'עברית',
  en: 'English',
  ar: 'العربية',
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
  ru: 'Русский',
  zh: '中文',
  ja: '日本語',
  ko: '한국어',
}

function getLanguageName(code: string): string {
  return LANGUAGE_NAMES[code] || code.toUpperCase()
}

interface ContentLanguagePickerProps {
  languages: string[]
  currentLang: string
  onChange: (lang: string) => void
}

const ContentLanguagePicker: React.FC<ContentLanguagePickerProps> = ({ languages, currentLang, onChange }) => {
  if (languages.length <= 1) {
    return null
  }

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value)
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1 }}>
      <LanguageIcon sx={{ fontSize: 18, color: 'var(--icon-default)' }} />
      <Select
        value={currentLang}
        onChange={handleChange}
        size="small"
        variant="standard"
        disableUnderline
        sx={{
          fontSize: '13px',
          color: 'var(--text-secondary)',
          '& .MuiSelect-select': {
            py: 0,
            pr: '20px !important',
          },
        }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang} value={lang} sx={{ fontSize: '13px' }}>
            <Typography sx={{ fontSize: '13px' }}>{getLanguageName(lang)}</Typography>
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}

export default ContentLanguagePicker
